// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ActionOut = zod.object({
  "description": zod.string(),
  "grants": zod.record(zod.string(), zod.boolean()),
  "key": zod.string(),
  "label": zod.string(),
  "scope": zod.union([zod.enum(['own', 'any']),zod.null()])
});

export type ActionOut = zod.input<typeof ActionOut>;
export type ActionOutOutput = zod.output<typeof ActionOut>;
